export const NumericType = 'numeric';
export const StringType = 'string';
export const WordType = 'word';

export const opsType = {
  numeric: 'op_num_equal',
  string: 'op_txt_is',
};
